module.exports = __webpack_public_path__ + "img/play-icon.5eacb21c.svg";